import { SaveType, BaseModel } from "@puntaje/shared/core"

export class PlanPersonalTipo extends BaseModel {
    public tipo: string
}
